<template>
  <div class="mb-8">
    <div class="col-photo-file">
      <img
        :src="
          img ? img : require(`../../assets/background/${this.background}.svg`)
        "
        alt="Licencia frontal"
        class="background-license"
        :class="{ 'background-license--error': error }"
      />
      <div @click="$emit('actuated')" class="button-file file-photo">
        <div class="label">
          <a-icon :name="icon" />
          <span>
            {{ label }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="form-text-validation form-text-validation--error text-center"
      v-if="error && img === ''"
    >
      <span class="text-validation">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import AIcon from '@/components/ui/AIcon';

export default {
  props: {
    background: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: String,
    img: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    error: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    AIcon,
  },
};
</script>
